import React from "react";
import NavigationIcon from "@mui/icons-material/Navigation";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { HEADER_HEIGHT } from "@/utils/constants";

export default function Map(props: any) {
  const { setMap, children } = props;
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_MAPS_KEY || "", // ,
    // ...otherOptions
  });

  const renderMap = () => {
    // wrapping to a function is useful in case you want to access `window.google`
    // to eg. setup options or create latLng object, it won't be available otherwise

    const loadHandler = (map: any) => {
      map.setCenter(props.center);
      setMap(map);
    };

    //comentado para que no se mueva el mapa al cambiar de marcador
    // const getCenter = () => {
    //   if (props.valuesState) {
    //     if (
    //       props.valuesState.current.lat == props.center.lat &&
    //       props.valuesState.current.lon == props.center.lng
    //     ) {
    //       return props.center;
    //     } else {
    //       return {
    //         lat: props.valuesState.current.lat,
    //         lng: props.valuesState.current.lon,
    //       };
    //     }
    //   }
    // };

    const changeRange = () => {
      if (props.map) {
        if (props.valuesState) {
          let distance = 50000;
          if (props.map.getZoom() >= 11) {
            distance = 50000;
          } else if (props.map.getZoom() == 10) {
            distance = 75000;
          } else if (props.map.getZoom() == 9) {
            distance = 100000;
          } else if (props.map.getZoom() == 8) {
            distance = 175000;
          } else if (props.map.getZoom() == 7) {
            distance = 250000;
          } else {
            distance = 1000000;
          }
          props.valuesState.current = {
            ...props.valuesState.current,
            lat: props.map.getCenter().toJSON().lat,
            lon: props.map.getCenter().toJSON().lng,
            distance: distance,
          };
        }
      }
    };

    return (
      <div style={{ position: "relative" }}>
        <GoogleMap
          id="circle-example"
          mapContainerStyle={{
            height:
              props.isMobile ? "calc(50vh)" : (
                "calc(100vh - " + HEADER_HEIGHT + ")"
              ),
            width: "100%",
          }}
          zoom={15}
          //@ts-ignore
          options={{
            streetViewControl: false,
            scaleControl: true,
            fullscreenControl: true,
            styles: [
              {
                featureType: "poi.business",
                elementType: "labels",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
            ],
            gestureHandling: "greedy",
            disableDoubleClickZoom: true,
            mapTypeControl: true,
            zoomControl: false,
            clickableIcons: false,
          }}
          onLoad={loadHandler}
          onDrag={() => {
            props.setShowButton(true);
            changeRange();
          }}
          onZoomChanged={() => {
            changeRange();
          }}
        >
          {children}
        </GoogleMap>
        <button
          className="location-button"
          onClick={() => {
            props.map.panTo({ lat: props.center.lat, lng: props.center.lng });
            props.map.setZoom(15);
            changeRange();
            props.changeValuesForFetch();
          }}
        >
          <NavigationIcon className="navigation-icon" />
        </button>
      </div>
    );
  };

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }

  return isLoaded ? renderMap() : <div>Loading...</div>;
}
